'use client';
import { useCallback, useState } from 'react';

import { BaseSelectInput } from './BaseSelectInput';

import type { BaseSelectInputProps } from './BaseSelectInput';

export type StandaloneSelectInputProps<T> = Omit<BaseSelectInputProps<T>, 'isOpen' | 'onOpen'>;

/**
 * A component that renders a search input and a list of items. When clicked, opens a modal with a search input and a list of items.
 */
export const StandaloneSelectInput = <T,>({ onChange, value, ...props }: StandaloneSelectInputProps<T>) => {
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
	const [selectedValue, setSelectedValue] = useState<null | T | undefined>(value || undefined);

	const handleSelect = useCallback(
		(item: T): void => {
			onChange?.(item);
			setSelectedValue(item);
			setIsModalOpen(false);
		},
		[onChange]
	);

	return (
		<BaseSelectInput
			isOpen={isModalOpen}
			value={selectedValue}
			onChange={handleSelect}
			onOpen={() => setIsModalOpen(true)}
			{...props}
		/>
	);
};
